/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UploadRouteImport } from './routes/upload'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DeployRouteImport } from './routes/deploy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as ProjectsFolderIdRouteImport } from './routes/projects.$folderId'
import { Route as PortfolioPortfolioIdRouteImport } from './routes/portfolio.$portfolioId'

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const TestimonialsRoute = TestimonialsRouteImport.update({
  id: '/testimonials',
  path: '/testimonials',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DeployRoute = DeployRouteImport.update({
  id: '/deploy',
  path: '/deploy',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
  id: '/portfolio/',
  path: '/portfolio/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsFolderIdRoute = ProjectsFolderIdRouteImport.update({
  id: '/projects/$folderId',
  path: '/projects/$folderId',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioPortfolioIdRoute = PortfolioPortfolioIdRouteImport.update({
  id: '/portfolio/$portfolioId',
  path: '/portfolio/$portfolioId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/deploy': typeof DeployRoute
  '/login': typeof LoginRoute
  '/testimonials': typeof TestimonialsRoute
  '/upload': typeof UploadRoute
  '/portfolio/$portfolioId': typeof PortfolioPortfolioIdRoute
  '/projects/$folderId': typeof ProjectsFolderIdRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/deploy': typeof DeployRoute
  '/login': typeof LoginRoute
  '/testimonials': typeof TestimonialsRoute
  '/upload': typeof UploadRoute
  '/portfolio/$portfolioId': typeof PortfolioPortfolioIdRoute
  '/projects/$folderId': typeof ProjectsFolderIdRoute
  '/portfolio': typeof PortfolioIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/about': typeof AboutRoute
  '/deploy': typeof DeployRoute
  '/login': typeof LoginRoute
  '/testimonials': typeof TestimonialsRoute
  '/upload': typeof UploadRoute
  '/portfolio/$portfolioId': typeof PortfolioPortfolioIdRoute
  '/projects/$folderId': typeof ProjectsFolderIdRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/about'
    | '/deploy'
    | '/login'
    | '/testimonials'
    | '/upload'
    | '/portfolio/$portfolioId'
    | '/projects/$folderId'
    | '/portfolio/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/about'
    | '/deploy'
    | '/login'
    | '/testimonials'
    | '/upload'
    | '/portfolio/$portfolioId'
    | '/projects/$folderId'
    | '/portfolio'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/about'
    | '/deploy'
    | '/login'
    | '/testimonials'
    | '/upload'
    | '/portfolio/$portfolioId'
    | '/projects/$folderId'
    | '/portfolio/'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  AboutRoute: typeof AboutRoute
  DeployRoute: typeof DeployRoute
  LoginRoute: typeof LoginRoute
  TestimonialsRoute: typeof TestimonialsRoute
  UploadRoute: typeof UploadRoute
  PortfolioPortfolioIdRoute: typeof PortfolioPortfolioIdRoute
  ProjectsFolderIdRoute: typeof ProjectsFolderIdRoute
  PortfolioIndexRoute: typeof PortfolioIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload'
      path: '/upload'
      fullPath: '/upload'
      preLoaderRoute: typeof UploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/testimonials': {
      id: '/testimonials'
      path: '/testimonials'
      fullPath: '/testimonials'
      preLoaderRoute: typeof TestimonialsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deploy': {
      id: '/deploy'
      path: '/deploy'
      fullPath: '/deploy'
      preLoaderRoute: typeof DeployRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/': {
      id: '/portfolio/'
      path: '/portfolio'
      fullPath: '/portfolio/'
      preLoaderRoute: typeof PortfolioIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$folderId': {
      id: '/projects/$folderId'
      path: '/projects/$folderId'
      fullPath: '/projects/$folderId'
      preLoaderRoute: typeof ProjectsFolderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio/$portfolioId': {
      id: '/portfolio/$portfolioId'
      path: '/portfolio/$portfolioId'
      fullPath: '/portfolio/$portfolioId'
      preLoaderRoute: typeof PortfolioPortfolioIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  AboutRoute: AboutRoute,
  DeployRoute: DeployRoute,
  LoginRoute: LoginRoute,
  TestimonialsRoute: TestimonialsRoute,
  UploadRoute: UploadRoute,
  PortfolioPortfolioIdRoute: PortfolioPortfolioIdRoute,
  ProjectsFolderIdRoute: ProjectsFolderIdRoute,
  PortfolioIndexRoute: PortfolioIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
